export class Consts {
	public static readonly AppId = 'myitero';
	public static ShellStoreName = 'ShellStore';
	public static ShowAllStore = 'show-all-store';
	public static FeatureToggleStoreName = 'FeatureToggleStore';
	public static CompanySoftwareOptionsName = 'CompanySoftwareOptionsStore';
	public static IosimSimulationInfoName = 'iosim-simulation-info';
	public static NavigationStore = 'NavigationStore';
	public static LabStore = 'LabStore';
	public static AccountManagementAppId = 'account-management-ui';
	public static readonly PatientManagementAppId = 'patient-mgmt-ui';
	public static AccountManagement = 'practice-management';
	public static readonly PatientManagement = 'patient-management';
	public static wrapper = 'wrapper';
	public static AxiContainer = 'axi-container';
	public static readonly visitReportAppId = 'itero-visit-reports';
	public static readonly selfServiceAppId = 'self-service-ui';
	public static readonly auth0Provider = 'auth0';
	public static readonly pingProvider = 'Ping';
	public static readonly azureProvider = 'azure';

	public static Storage = {
		Settings: 'settings',
		Routes: 'routes',
		RegionalApiEndpoint: 'regionalApiEndpoint',
		ServerVersion: 'serverVersion',
		SessionInfo: 'sessionInfo',
		TransitionsStack: 'transitionsStack',
		Logo: 'logo',
		Region: 'region',
		AkitaStores: 'AkitaStores',
		ExportModalImageBg: 'export-modal-image-bg',
	};

	public static TablesIds = {
		PracticeUsers: 'practice-users-table',
		PracticeInvitations: 'practice-invitations-table'
	};

	public static GoogleApiAddressTypes = {
		Locality: 'locality',
		PostalCode: 'postal_code',
		Country: 'country',
		AdministrativeAreaLevel1: 'administrative_area_level_1'
	};

	public static HeaderKeys = {
		SelectedDoctorId: 'X-Doctor-ID',
		SelectedCompanyId: 'X-Company-ID',
		Authorization: 'Authorization',
		LogonAsId: 'X-LogonAs-ID',
		SessionId: 'x-session-id'
	};

	public static SessionType = 'web';

	public static Resolution = {
		Mobile: 768
	};

	public static Enablers = {
		isCaseFlowManagementEnabled: 'isCaseFlowManagementEnabled',
		isShare3DPreviewEnabled: 'isShare3DPreviewEnabled'
	};

	public static Context = {
		CaseFlowManagement: 'CaseFlowManagement',
		Share3DPreview: 'Share3DPreview'
	};

	public static RefreshTokenPath = 'session/refresh?sessionId={0}&appId={1}';
	public static LogoutPath = 'authorize/logout';
	
	public static NavigationCommands = new Map<string, any[]>([
			['iosim', ['/', 'doctors', 'iosim-plus']],
			['itero-visit-reports', ['/', 'app', 'itero-visit-reports']],
			['axi-wrapper', ['/', 'app', 'axi-wrapper']]
	]);

	public static CookiesNames = {
		RETURNURL: 'RETURNURL',
		SWITCHREGIONURL: 'SWITCHREGIONURL'
   };
	
}
